(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/user/confirm-registration', {}, {
            'post': { method: 'POST', params: {}, isArray: false}
        });

        return service;
    }
})();
